import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsIheartradioComponent } from './simple-icons-iheartradio.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsIheartradioComponent ],
    exports:      [ SimpleIconsIheartradioComponent ],
    bootstrap:    []
})
export class SimpleIconsIheartradioModule {}
